// @flow
import styled from 'styled-components';
import {
  py, mb, px, p
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import { fontButtonLink } from '@styles/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@theme';

const { colors, borderRadius } = theme;

export const StyledLoginForm = styled.form`
  display: flex;
  flex-direction: column;
  padding-left: 15%;
  padding-right: 15%;
  justify-content: center;
`;

export const StyledInput = styled.input`
  border: none;
  ${borderRadius.small}
  background-color: ${props => (props.greyblue ? colors.greyBlue10 : 'rgb(87 87 87 / 14%)')};
  font-weight: 500;
  font-size: 16px;
  border-radius: 15px !important;
  border-bottom: 1px solid transparent;
  
  ${({ error }) =>
    error
    && `
    color: ${colors.error};
    border-bottom: solid 1px ${colors.error};
  `}

  ${py(2.5)}
  ${px(3)}
  ${mb(2)}

  ::placeholder {
    color: ${colors.gray};
  }

  ${breakpoint('desktop')`
    color: ${colors.darkBlue};
    background-color: ${colors.greyBlue10};
    ::placeholder {
      color: ${colors.translucentDarkBlue};
    }
  `}
  ${breakpoint('mobile', 'desktop')`
     margin-bottom: 30px !important;
  `}
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > * {
    font-family: 'Open Sans', sans-serif;
  }
  & > *:first-child {
    ${mb(3.5)}
    ${py(2.5)}
    font-size: 16px;
  }
  & > *:last-child {
    ${mb(0)}
    ${p(3)}
    font-size: 14px;
    ${breakpoint('desktop')`
      font-size: 16px;
    `}
  }
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${colors.black};
  position: absolute;
  top: 0;
  left: 0;
  ${p(3)}
`;

export const StyledButtonLinkInverted = styled.a`
  ${fontButtonLink}
  ${p(3)}
  text-align: center;
  cursor: pointer;
  width: 100%;
  background-color: transparent;
  border: none;
  font-weight: 500;
`;

export const StyledButtonLinkTransparentWhite = styled.a`
  ${fontButtonLink}
  ${p(3)}
  cursor: pointer;
  color: black !important;
  font-size: 15px;
  display: flex;
  flex-direction: column !important ;
  background-color: transparent;
  justify-content: center;
  border: none;
  font-weight: normal;
  & > .underline {
    text-decoration: underline;
    font-weight: 500;
  }
  &:hover {
    color: ${colors.white};
  }
  .underline {
    margin-left: 15px;
    margin-top: 7px;
  }
`;

export const StyledErrorMessage = styled.p`
  color: ${colors.error};
  font-weight: normal;
  font-size: 14px;
  ${py(1)}
`;
